<div class="uploader-list">
  <div *ngFor="let f of files" class="uploader-item">
    <nz-avatar nzSize="large" [nzText]="getSuffix(f.name)" style="color: #f56a00; background-color: #fde3cf"></nz-avatar>
    <a *ngIf="f.path" [href]="getPath(f.path)" nz-tooltip [nzTooltipTitle]="f.name" target="_blank">{{ getSimpleName(f.name) }}</a>
  </div>
</div>
